module.exports = __webpack_public_path__ + "img/img-title.e4934e2b.png";